import React from 'react';
import CustomScrollbars from 'util/CustomScrollbars';
import Moment from 'moment';
import IntlMessages from 'util/IntlMessages';
import { addressString } from 'components/FormattedAddress';

const GeneralNotification = ({ notifications, toReference, reports, onInvalidClick }) => {
	Moment.locale('de');
	return (
		<CustomScrollbars className="messages-list scrollbar" style={{ height: notifications.length > 0 ? 280 : 61 }}>
			<ul className="list-unstyled">
				{notifications.length > 0 ? (
					notifications.map(({ notificationId, notificationIcon, title, date, link, highlighted, reportId }) => {
						const report = reports.find(r => r.reportId === reportId);
						const valid = report ? true : false;
						return (
							<li
								className={`media pointer ${highlighted ? (valid ? 'bg-blue lighten-1' : 'bg-red lighten-2') : ''}`}
								onClick={() => (valid ? toReference(link, notificationId) : onInvalidClick(notificationId, reportId))}
								key={notificationId}
							>
								<div className="d-flex align-items-center pr-3">
									<i className={`zmdi ${notificationIcon} zmdi-hc-2x ${highlighted ? 'text-white' : 'text-dark'}`} />
								</div>
								<div className="media-body align-self-center">
									<p className={`heading mb-0 ${highlighted ? 'text-white' : 'text-dark'}`}>{title}</p>
									{valid && (
										<p className={`sub-heading ${highlighted ? 'text-white' : 'text-dark'}`}>{`${
											report.type && report.type.name ? `${report.type.name}` : ''
										}${addressString(report) ? ` | ${addressString(report)}` : ''}`}</p>
									)}
									<span className={`meta-date ${highlighted ? 'text-white' : 'text-dark'}`}>
										<small>{Moment(date).fromNow()}</small>
									</span>
								</div>
							</li>
						);
					})
				) : (
					<li className="w-100">
						<div className="media-body">
							<div className="d-flex justify-content-center align-items-center">
								<h5 className="text-muted">
									<IntlMessages id="header.chatNotifications.noNotifications" />
								</h5>
							</div>
						</div>
					</li>
				)}
			</ul>
		</CustomScrollbars>
	);
};

export default GeneralNotification;



// WEBPACK FOOTER //
// ./containers/Header/Component/GeneralNotifications.js